import type { PartnerEnum } from '../groveSchedulerClient'
import { getPartnerBaseUrl } from './partnerEnvironment'
import type { PartnerSchemaInternal } from './types'

/**
 * Build OAuth authorization URL for Eyefinity
 * Uses the environment-appropriate base URL (staging / prod-uk / prod-us).
 *
 * @param agentId - The agent ID to authorize
 * @returns Complete OAuth authorization URL
 */
export const buildEyefinityOAuthUrl = (agentId: string): string => {
  const base = getPartnerBaseUrl()
  return `${base}/eyefinity/authorize?agent_id=${encodeURIComponent(agentId)}`
}

/**
 * Eyefinity partner configuration schema
 * Requires the Eyefinity Office ID. Tokens arrive through OAuth, so the
 * agent stays inactive until authorization succeeds.
 */
export const eyefinitySchema: PartnerSchemaInternal = {
  partner: 'eyefinity' as PartnerEnum,
  displayName: 'Eyefinity',
  fields: [
    {
      key: 'organization_id',
      label: 'Office ID',
      type: 'text',
      required: true,
      placeholder: 'API9',
      helperText: 'The Eyefinity Office ID for this practice.',
    },
  ],
  requiresOAuth: true,
  activateAfterOAuth: true,
  buildOAuthUrl: buildEyefinityOAuthUrl,
  postCreationInfo:
    'After creating this agent, someone with Eyefinity credentials for the practice must authorize it from the agent details page. Resume the agent once authorization succeeds.',
  authHelp:
    'If authorization fails, verify the Office ID and that the Eyefinity account can access that practice.',
}
